import { REPORT, REPORT_RANGE } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { average, countUnique, sum } from '@utils/summaries';
import { basicSort, dateSort } from '@utils/sort';
import { styleDateRange } from '@utils/styles';

interface MaterialCutsByLocationProps {
    dateRange: { startDate: string; endDate: string };
}

export const MaterialCutsByLocation = ({ dateRange }: MaterialCutsByLocationProps) => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.LOCATION_MATERIAL_TYPE_CUTS_BY_LOCATION,
        params: { ...dateRange, range: 'monthly' },
    });

    return (
        <BaseReport
            title={'Material Type Cuts by Location'}
            description={
                'This table shows you the % breakdown of each material type by location for the time period selected in the date range above.'
            }
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: [
                    'Date',
                    'Company Name',
                    'Reseller Name',
                    'Location Name',
                    'Successful Cuts',
                    'Original Cut %',
                    'Matte Cut %',
                    'Fusion Cut %',
                    'Style Skins Cut %',
                    'Pruvia Cut %',
                ],
                data: data.map((item) => [
                    item.date,
                    item.companyName,
                    item.resellerName,
                    item.locationName,
                    item.successfulCuts,
                    item.originalPct,
                    item.mattePct,
                    item.fusionPct,
                    item.styleSkinPct,
                    item.pruviaPct,
                ]),
                summaries: [countUnique, countUnique, countUnique, countUnique, sum, average, average, average, average, average],
                sort: [
                    dateSort(REPORT_RANGE.MONTHLY),
                    basicSort,
                    basicSort,
                    basicSort,
                    basicSort,
                    basicSort,
                    basicSort,
                    basicSort,
                    basicSort,
                    basicSort,
                ],
            }}
        />
    );
};
